export enum ComponentTool {
    Rulebook = 0,
    Mersy = 1,
    UMP = 2,
    Undefined = -1
}
